const visualImpairmentStatuses = {
  New: 1,
  InProcess: 2,
  Submitted: 3,
  Cancelled: 4,
  Returned: 5
};

const getVisualImpairmentStatusColor = statusId => {
  switch (statusId) {
    case visualImpairmentStatuses.New:
      return "secondary-2";
    case visualImpairmentStatuses.InProcess:
      return "yellow";
    case visualImpairmentStatuses.Submitted:
      return "green-light";
    case visualImpairmentStatuses.Returned:
      return "violet";
    case visualImpairmentStatuses.Cancelled:
      return "brown";
    default:
      return "secondary-2";
  }
};

export default visualImpairmentStatuses;
export { visualImpairmentStatuses, getVisualImpairmentStatusColor };
